import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

export function ItemLockInPlaceOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const lockMovement = useGetKeyFromActiveItem('lockMovementX');

  if (lockMovement === undefined) {
    throw new Error("item doesn't have lockMovement property");
  }

  const onClickHandler = (): void => {
    void activeItem?.updateLock(!lockMovement);
  };

  return <ContextualMenuToggleOption onClick={onClickHandler} isChecked={lockMovement} id="item-lock-in-place-option" label={window.i18next.t('pmwjs_lock_in_place')} />;
}
